export default __webpack_public_path__ + "static/media/removeService.34bc692e.svg";